import { AdminService } from './../../../services/admin.service';
import { OrganisationService } from './../../../services/organisation.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/internal/operators/first';
import { Role } from 'src/app/models';
import { DatePipe } from '@angular/common';
import { fromEvent } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { debounceTime, distinctUntilChanged, tap, concatMap } from 'rxjs/operators';
import * as jquery from 'jquery';
import { NgbDate, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment-timezone';
import 'moment/locale/en-nz';
import { Months } from 'src/app/helpers/date-picker/months';

declare var require: any;

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit, AfterViewInit {

  @ViewChild('searchUserInput') searchUserInput: ElementRef;

  users: Array<{
    id: number;
    firstName: string;
    lastName: string;
    fullName: string;
    email: string;
    suspended: string;
    lastLogin: number;
    signedUp: number;
    roleName: string;
    role: Role;
    avatar: string;
    organisationId: number;
    organisation: string;
    organisationType: string;
    subscriptionId: number;
  }> = [];
  currentPage: number;
  lastPage: number;
  pageLinks: number[] = [];
  searchValue = '';
  searchStatusVal = '';
  searchRoleVal = '';
  usersTotal = 0;
  editUserForm: FormGroup;
  submitted = false;
  roles = [
    {
      id: 1,
      value: Role.Individual,
      text: 'Individual'
    },
    {
      id: 2,
      value: Role.Employee,
      text: 'Employee'
    },
    {
      id: 3,
      value: Role.Manager,
      text: 'Manager'
    },
    {
      id: 4,
      value: Role.Admin,
      text: 'Administrator'
    },
  ];
  userId: number;
  userRole: string;
  userSubscriptionId: number;
  submitError = false;
  submitErrorMsg = '';
  error = false;
  modalText = 'Loading...';
  loading = true;
  organisations = [];
  organisationId: number;
  userCurrentStatus: number;
  userCurrentRole: string;
  userStatus: number;

  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  fromUnixTimestamp = '';
  toUnixTimestamp = '';
  dpFromDate: NgbDate;
  dpToDate: NgbDate;


  individualPrompt: boolean;
  nonIndividualPrompt: boolean;

  activePrompt: boolean;
  inactivePrompt: boolean;

  statusOptions = [
    {
      id: 1,
      value: 1,
      text: 'Inactive'
    },
    {
      id: 2,
      value: 0,
      text: 'Active'
    }
  ];

  readonly DELIMITER = '-';

  constructor(
    private pageTitleService: Title,
    private route: ActivatedRoute,
    private adminService: AdminService,
    private organisationService: OrganisationService,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter
  ) { }

  ngOnInit(): void {
    this.setPageTitle();
    this.setFormControls();
    this.loadData();
    this.userStatus = 0;
  }

  ngAfterViewInit(): void {
    this.search();
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Users');
  }

  setFormControls() {
    this.editUserForm = new FormGroup({
      userRole: new FormControl('', [
        Validators.required
      ]),
    });
  }

  onDateFromSelection(fromDate: NgbDate) {
    this.fromDate = fromDate;
    const fromDateF = this.fromDate.day + '/' + this.fromDate.month + '/' + this.fromDate.year;
    if (this.toDate) {
      if (this.fromDate.after(this.toDate)) {
        jquery('#dateInputFrom').val(fromDateF);
        this.fromDate = fromDate;

        this.toDate = null;
        this.toUnixTimestamp = '';
        this.dpToDate = null;
      } else {
        jquery('#dateInputFrom').val(fromDateF);
      }
    }
    this.onDateSelection();
  }

  onDateToSelection(toDate: NgbDate) {
    this.toDate = toDate;
    const toDateF = this.toDate.day + '/' + this.toDate.month + '/' + this.toDate.year;
    if (this.fromDate) {
      if (this.toDate.before(this.fromDate)) {
        jquery('#dateInputFrom').val(toDateF);
        this.fromDate = toDate;

        jquery('#dateInputTo').val('');
        this.toDate = null;
        this.toUnixTimestamp = '';
        this.dpToDate = null;
      } else {
        jquery('#dateInputTo').val(toDateF);
      }
    }
    this.onDateSelection();
  }

  onDateSelection() {
    // Get the Unix Timestamp for DateFrom and DateTo
    if (this.fromDate && this.toDate) {

      // Handles From Date Conversion to timestamp
      const fromMonth = (this.fromDate.month < 10) ? '0' + this.fromDate.month : this.fromDate.month;
      const fromDay = (this.fromDate.day < 10) ? '0' + this.fromDate.day : this.fromDate.day;
      const fromYear = this.fromDate.year;
      const fromDate = fromYear + '-' + fromMonth + '-' + fromDay + ' 00:00:00';
      this.fromUnixTimestamp = moment.tz(fromDate.toString(), 'YYYY-MM-DD HH:mm:ss', moment.tz.guess()).format('X');

      // Handles To Date Conversion to timestamp
      const toMonth = (this.toDate.month < 10) ? '0' + this.toDate.month : this.toDate.month;
      const toDay = (this.toDate.day < 10) ? '0' + this.toDate.day : this.toDate.day;
      const toYear = this.toDate.year;
      const toDate = toYear + '-' + toMonth + '-' + toDay + ' 23:59:59';
      this.toUnixTimestamp = moment.tz(toDate.toString(), 'YYYY-MM-DD HH:mm:ss', moment.tz.guess()).format('X');

    }

    if (this.fromUnixTimestamp !== '' && this.toUnixTimestamp !== '') {
      this.modalText = 'Searching...';
      this.loadData(1, this.searchValue, this.fromUnixTimestamp, this.toUnixTimestamp, this.searchStatusVal, this.searchRoleVal);
    }

  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  clearDateFrom() {
    if (this.fromDate) {
      jquery('#dateInputFrom').val('');
      this.fromDate = null;
      this.fromUnixTimestamp = '';
      this.dpFromDate = null;
      this.loadData(1, this.searchValue, this.fromUnixTimestamp, this.toUnixTimestamp, this.searchStatusVal, this.searchRoleVal);
    }
  }

  clearDateTo() {
    if (this.toDate) {
      jquery('#dateInputTo').val('');
      this.toDate = null;
      this.toUnixTimestamp = '';
      this.dpToDate = null;
      this.loadData(1, this.searchValue, this.fromUnixTimestamp, this.toUnixTimestamp, this.searchStatusVal, this.searchRoleVal);
    }
  }

  loadData(pageNumber: number = 1, searchValue: string = '', dateFrom: string = '', dateTo: string = '', status="", searchRoleVal: string = '') {

    // Show progress modal
    this.showProgressModal();
    this.adminService.list(pageNumber, searchValue, dateFrom, dateTo, status, searchRoleVal)
      .pipe(
        map(userData => userData.data),
        tap(userData => {
          this.users = [];
          userData?.users.forEach(user => {
            let userRole: string = user?.role;
            userRole = userRole.charAt(0).toUpperCase() + userRole.slice(1);

            this.users.push({
              id: user.id,
              firstName: user?.first_name,
              lastName: user?.last_name,
              fullName: user?.first_name + ' ' + user?.last_name,
              email: user?.email,
              suspended: user?.suspended,
              lastLogin: user?.last_login,
              signedUp: user?.signed_up,
              roleName: userRole,
              role: user?.role,
              avatar: (user?.avatar !== '') ? user?.avatar : require('../../../../assets/images/avatars/default_profile.png'),
              organisationId: (user.organisation?.id > 0) ? user.organisation?.id : 0,
              organisation: (user.organisation?.id > 0) ? user.organisation?.name : '___',
              organisationType: (user.organisation?.id > 0) ? user.organisation?.type : '',
              subscriptionId: (user.subscription?.id) ? user.subscription?.id : 0,
            });
          });

          const totalRecords = userData.pagination?.total_records;
          this.lastPage = userData.pagination?.last_page;
          this.pageLinks = [];
          if (totalRecords > 0) {
            this.currentPage = userData.pagination?.current_page;
            for (let index = 1; index <= this.lastPage; index++) {
              this.pageLinks.push(index);
            }
          }

          this.usersTotal = totalRecords;
        }),

        // Get Organisation Listing
        concatMap(() => this.organisationService.listAll()),
        map(orgData => orgData.data),
        tap(orgData => {
          this.organisations = [];
          const tempOrganisations = orgData.organisation;
          Object.keys(tempOrganisations).forEach(key => {
            this.organisations.push({
              id: key,
              name: tempOrganisations[key]
            });
          });
          this.organisations.sort(this.sortByValues);

          jquery('#organisationSelect').select2(
            {
              theme: 'matarial',
              width: '100%',
              placeholder: 'Organisation'
            }
          );

          // Calls Select 2 Change event
          this.organisationOnChange();

        })
      )
      .subscribe(
        response => {
          if (response !== undefined) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
              this.loading = false;
            }, 500);
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  paginate(pageNumber: number) {
    if (pageNumber > 0) {
      this.loadData(pageNumber, this.searchValue, this.fromUnixTimestamp, this.toUnixTimestamp, this.searchStatusVal, this.searchRoleVal);
    }
  }

  searchStatus() {
    this.loadData(1, this.searchValue, this.fromUnixTimestamp, this.toUnixTimestamp, this.searchStatusVal, this.searchRoleVal);
  }

  search() {
    fromEvent(this.searchUserInput.nativeElement, 'keyup')
      .pipe(
        map((event: any) => {
          this.searchValue = event.target.value;
          return event.target.value;
        }),
        debounceTime(2000),
        distinctUntilChanged()
      )
      .subscribe((text: string) => {
        this.modalText = (text !== '') ? 'Searching...' : 'Loading...';
        this.loadData(1, text, this.fromUnixTimestamp, this.toUnixTimestamp, this.searchStatusVal, this.searchRoleVal);
      });
  }

  getUserAttributes(data: any) {
    this.userId = data?.id;
    this.f.userRole.setValue(data?.role);
    this.userRole = data?.role;
    this.userSubscriptionId = data?.subscriptionId;

    // Sets the value of the organisation select input
    jquery('#organisationSelect').val(data?.organisationId).trigger('change');

    this.organisationId = data?.organisationId;
    this.showOrganisation();

    // Resets Submit Error
    this.submitError = false;
  }

  getUserStatus(data: any) {
    this.userId = data?.id;
    this.userSubscriptionId = data?.subscriptionId;
    this.userCurrentStatus = data?.suspended;
    this.userCurrentRole = data?.role;
    this.userStatus = data?.suspended;

    // Resets Submit Error
    this.submitError = false;
    this.activePrompt = false;
    this.inactivePrompt = false;
  }

  // Convenience getter for easy access to form fields
  get f() { return this.editUserForm.controls; }

  organisationOnChange() {
    jquery('#organisationSelect').on('select2:select', (e) => {
      const data = e.params.data;
      this.organisationId = data.id;
      jquery('#organisationSelect').removeClass('error');
      jquery('#orgLabel').show();
    });
  }

  changeStatus() {
    this.activePrompt = false;
    this.inactivePrompt = false;
    if (this.userStatus == 1) { // suspend
      if (this.userCurrentStatus == 0) {
        if (this.userSubscriptionId) {
          this.inactivePrompt = true;
        }
      }
    } else { // activate
      if (this.userCurrentStatus == 1) {
        if (this.userCurrentRole == "individual") {
          this.activePrompt = true;
        }
      }
    }
  }

  updateUserStatus() {

    if ((this.userCurrentStatus != this.userStatus) && (this.userStatus != undefined)) {

      // Show progress modal
      this.showProgressModal();

      this.adminService.adminUpdateUserStatus(this.userId, this.userStatus)
        .pipe(first())
        .subscribe(
          userData => {

            if (userData.success) {
              const closeModalButton: HTMLElement = document.getElementById('close-editStatusModal-modal');
              closeModalButton.click();
              this.submitted = false;
              this.userCurrentStatus = this.userStatus;
              this.loadData(this.currentPage, this.searchValue, this.fromUnixTimestamp, this.toUnixTimestamp, this.searchStatusVal, this.searchRoleVal);

              setTimeout(() => {
                // Hides progress modal
                this.hideProgressModal();
              }, 500);
            }

            if (!userData.success && userData.error?.code === 422) {
              setTimeout(() => {
                // Hides progress modal
                this.hideProgressModal();
              }, 500);

              this.f.userRole.setValue(this.userRole);
              this.submitted = false;
              this.submitError = true;
              this.submitErrorMsg = userData.error?.msg;
            }
          },
          error => {
            // Hides progress modal
            this.hideProgressModal();
            this.submitError = true;
            this.submitted = false;
          }
        );

    } else {
      const closeModalButton: HTMLElement = document.getElementById('close-editStatusModal-modal');
      closeModalButton.click();
    }
  }

  updateUserRole() {

    this.submitted = true;

    // Stop here if there's form errors
    if (this.editUserForm.invalid) {
      return;
    }

    if (this.f.userRole.value == 'employee' && this.organisationId == 0 ||
      this.f.userRole.value == 'manager' && this.organisationId == 0) {
      const orgSelect: HTMLElement = document.getElementById('organisationSelect');
      orgSelect.classList.add('error');
      return;
    }

    // Show progress modal
    this.showProgressModal();

    this.adminService.adminUpdateUserRole(this.userId, this.f.userRole.value, this.organisationId)
      .pipe(first())
      .subscribe(
        userData => {

          if (userData.success) {
            const closeModalButton: HTMLElement = document.getElementById('close-editUserModal-modal');
            closeModalButton.click();
            this.submitted = false;
            this.loadData(1, this.searchValue, this.fromUnixTimestamp, this.toUnixTimestamp, this.searchStatusVal, this.searchRoleVal);

            setTimeout(() => {
              // Hides progress modal
              this.hideProgressModal();
            }, 500);
          }

          if (!userData.success && userData.error?.code === 422) {
            setTimeout(() => {
              // Hides progress modal
              this.hideProgressModal();
            }, 500);

            this.f.userRole.setValue(this.userRole);
            this.submitted = false;
            this.submitError = true;
            this.submitErrorMsg = userData.error?.msg;
          }
        },
        error => {
          // Hides progress modal
          this.hideProgressModal();
          this.submitError = true;
          this.submitted = false;
        }
      );

  }

  showOrganisation() {

    this.individualPrompt = false;
    this.nonIndividualPrompt = false;

    const CurrentRole = this.userRole;
    const role = this.f.userRole.value;
    const orgContainer: HTMLElement = document.getElementById('organisationFormContainer');
    if (role === 'employee' || role === 'manager') {
      orgContainer.classList.remove('d-none');
      orgContainer.classList.add('d-block');
    } else {
      orgContainer.classList.add('d-none');
      orgContainer.classList.remove('d-block');
    }

    if (this.organisationId == 0) {
      jquery('#orgLabel').hide();
    } else {
      jquery('#orgLabel').show();
    }

    if (CurrentRole != 'individual' && role == 'individual') {
      this.individualPrompt = true;
    }

    if (CurrentRole == 'individual' && role != 'individual' && this.userSubscriptionId > 0) {
      this.nonIndividualPrompt = true;
    }

  }

  private sortByValues(a, b) {
    const bandA = a.name.toUpperCase();
    const bandB = b.name.toUpperCase();

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
